export default __webpack_public_path__ + "static/media/_kers.9fc19b53.png";